// @flow

import type {ApiSuccess} from '@travel-frontend/state-handling-sdk';
import type {AsyncAction} from 'redux/types';

import {ASYNC_TYPES} from '@travel-frontend/state-handling-sdk';
import axios from 'axios';

import {config as cfg} from 'config';

export const POST_SERVICE_FEEDBACK = 'v1/voucher/POST_SERVICE_FEEDBACK';

export type PostServiceFeedbackSuccess = ApiSuccess<[], *>;

export const sendServiceFeedback = (
  journeyId: number,
  token: string,
  ratingScore: number,
  ratingText?: string
): AsyncAction => {
  const config = {
    headers: {Authorization: `Bearer ${token}`},
  };

  return {
    types: ASYNC_TYPES(POST_SERVICE_FEEDBACK),
    callAPI: () =>
      axios
        .post(
          `${cfg.bookingServiceUrl}/servicefeedback/${journeyId}`,
          {ratingScore, ratingText},
          config
        )
        .then((r) => r.data)
        .catch((error) => { throw error.response.data; }),
  };
};
